// Libs
import React, { ReactElement } from 'react';
import Link from 'next/link';
import { useSession, signOut } from 'next-auth/react';
import { Button } from 'ui-components';
// App
import { useGetAccount } from 'app-shared/lib/api/user-access/account';
import { hasValidAccessToken } from 'app-shared/lib/api/user-access/auth/access-token.utils';
import { USER_ACCESS_PAGES_URLS } from '@/fragments/user-access/user-access.constants';

import UserAvatar from './user-avatar';

const UserNavContent = (): ReactElement => {
  const { data: session, status } = useSession();
  const hasSessionWithValidAccessToken = hasValidAccessToken(session);
  const { data: account } = useGetAccount(hasSessionWithValidAccessToken, signOut);
  const isSessionLoading = status == 'loading';

  /**
   * Template when user is not signed in
   */
  const signedOutTemplate = (
    <>
      <Link href={USER_ACCESS_PAGES_URLS['login']}>
        <Button variant="text" color="tertiary">
          Espace pro
        </Button>
      </Link>
    </>
  );

  /**
   * Template when user is signed in
   */
  const signedInTemplate = <UserAvatar account={account} />;

  if (isSessionLoading) return null;

  return (hasSessionWithValidAccessToken && signedInTemplate) || signedOutTemplate;
};

export default UserNavContent;
